import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    layoutMode: (state) => state.layoutMode,
    layoutScrollable: (state) => state.layoutScrollable,
    sidebarColor: (state) => state.sidebarColor,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutMode', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar',
'changeLoaderValue', 'changeLayoutPosition','changeSidebarColor'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])
